import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { WidgetHeaderComponent } from '@platform/dashboard/components/widget-container/components/widget-header/widget-header.component';
import { paths } from '@platform/paths';
import { ADD_NEW_PROPERTY_PAGE_ID } from '@platform/portfolio/pages/portfolio-carousel/portfolio-carousel.store';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { AppState } from '@shared/models/app-state.model';
import { dismissClientUserLandlordPropertyBanner } from '@shared/store/client-user/client-user.actions';
import {
  selectClientUserDeclaredNumberOfProperties,
  selectClientUserRemainingPropertiesNumber,
} from '@shared/store/client-user/client-user.selectors';
import { selectPropertiesNumber } from '@shared/store/properties/properties.selectors';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cp-widget-add-landlord-properties',
  imports: [ButtonDirective, WidgetHeaderComponent, IconComponent, AsyncPipe],
  templateUrl: './widget-add-landlord-properties.component.html',
  styleUrls: ['../../shared/widget.scss', './widget-add-landlord-properties.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetAddLandlordPropertiesComponent {
  private readonly router = inject(Router);
  private readonly store = inject(Store<AppState>);

  protected readonly selectClientUserDeclaredNumberOfProperties$ = this.store.select(selectClientUserDeclaredNumberOfProperties);
  protected readonly selectClientUserRemainingProperties$ = this.store.select(selectClientUserRemainingPropertiesNumber);
  protected readonly selectPropertiesNumber$ = this.store.select(selectPropertiesNumber);

  addPropertyRedirect(): void {
    void this.router.navigate(['/', paths.PLATFORM, paths.platform.PROPERTIES], { queryParams: { id: ADD_NEW_PROPERTY_PAGE_ID } });
  }

  discard(): void {
    this.store.dispatch(dismissClientUserLandlordPropertyBanner());
  }
}
